// NGRX
import { createSelector } from '@ngrx/store';
// Lodash
import { unionBy, intersectionBy } from 'lodash';
// Models
import { Permission } from '../_models/permission.model';

export const selectAuthState = (state) => state.auth;

export const isLoggedIn = createSelector(selectAuthState, (auth) => auth.loggedIn);

export const isLoggedOut = createSelector(isLoggedIn, (loggedIn) => !loggedIn);

export const currentAuthToken = createSelector(selectAuthState, (auth) => auth.authToken);

export const isUserLoaded = createSelector(selectAuthState, (auth) => auth.isUserLoaded);

export const currentUser = createSelector(selectAuthState, (auth) => auth.user);

export const currentUserPermissions = createSelector(currentUser, (user) => {
  if (!user) {
    return [];
  }

  const rolesPermissions: Permission[] = [];
  user.roles.forEach((role: any) => rolesPermissions.concat(role.permissions));
  return unionBy(intersectionBy(rolesPermissions, user.permissions, 'id'), user.permissions, 'id');
});

export const checkHasUserPermission = (permissionId: number) =>
  createSelector(currentUserPermissions, (permissions: any[]) => {
    return permissions.some((perm) => perm.id === permissionId);
  });
